import SalesPeDoshSubscriberThumb from 'assets/icons/ReportThumbs/sales_per_dosh_subscriber.png';

export default [
  {
    key: 'salesPerSubscriberOverallLift',
    text: 'Sales Per Subscriber (Overall Lift)',
    image: SalesPeDoshSubscriberThumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Control Group',
      border: true,
    },
  },
  {
    key: 'aovOverallLift',
    text: 'AOV (Overall Lift)',
    image: SalesPeDoshSubscriberThumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Control Group',
      border: true,
    },
  },
  {
    key: 'frequencyOverallLift',
    text: 'Frequency (Overall Lift)',
    image: SalesPeDoshSubscriberThumb,
    meta: {
      thirdPartyReport: false,
      showForOnline: true,
      type: 'Control Group',
      border: true,
    },
  },
];
